module.exports = __webpack_public_path__ + "media/images/okra-offers/mobile-img-642d2ba33b7fb40dbc2e5cb9b21d7ac3.png";